import React from 'react';
import { Link } from 'react-router-dom';
import Services from "../../api/Services";

import Topimage from '../../images/service/service-bg.jpg'

const ServiceSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const limitWords = (text, words = 30) => {
        const wordArray = text.split(" ");
        if (wordArray.length <= words) return text;
        return wordArray.slice(0, words).join(" ") + "...";
    };

    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid p-0">
                <div className="service-top">
                    <div className="image">
                        <img src={Topimage} alt="service-bg" />
                    </div>
                    <div className="content">
                        <h2 className="fade_bottom">
                            End-to-End Real Estate Services You Can Trust
                        </h2>
                        <p className="fade_bottom">
                            Luxrock Realty delivers comprehensive residential, commercial, and industrial
                            property solutions. From buying and selling to leasing and pre-leased
                            investments, we guide you with market expertise, verified properties, and
                            complete transparency at every step.
                        </p>
                    </div>

                </div>
                <div className="service-wrap">
                    <div className="row">
                        {Services.slice(0, 4).map((service, item) => (
                            <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={item}>
                                <div className="inner-service-card">
                                    <div className="icon">
                                        <img src={service.Icon} alt="icon" />
                                    </div>
                                    <h3><Link onClick={ClickHandler} to={`/our-services/${service.slug}`} className='text-black'>{service.title}</Link></h3>
                                    <p>{service.Subtitle}</p>
                                    <p className='mt-4'>{limitWords(service.overview, 10)}</p>
                                    <p><Link onClick={ClickHandler} to={`/our-services/${service.slug}`} className='service-link'>View Details</Link></p>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;

